import { ms } from '../../util';

export const CUSTOM_OFFSET_PREFIX = 'cof';

export const CUSTOM_OFFSET_LIMITS = {
  MIN_OFFSET: ms('1m'),
  MAX_OFFSET: ms('1y'),
} as const;

export const MESSAGE_TYPES = {
  CONFIRMATION: 'confirmation',
  REMINDER: 'reminder',
  FOLLOW_UP: 'follow_up',
} as const;

export type CustomOffsetMessageType =
  (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

export interface OffsetOption {
  value: string;
  label: string;
  short: string;
  id?: string;
  is_custom?: boolean;
}

export const hardcodedConfirmationOffsets: OffsetOption[] = [
  { value: '0', label: 'Immediately after saving', short: 'Immediately' },
  {
    value: `${ms('15m')}`,
    label: '15 minutes after saving',
    short: '15 minutes',
  },
  {
    value: `${ms('30m')}`,
    label: '30 minutes after saving',
    short: '30 minutes',
  },
  { value: `${ms('1h')}`, label: '1 hour after saving', short: '1 hour' },
];

export const hardcodedReminderOffsets: OffsetOption[] = [
  {
    value: `${ms('30m')}`,
    label: '30 minutes before the event',
    short: '30 minutes',
  },
  { value: `${ms('1h')}`, label: '1 hour before the event', short: '1 hour' },
  { value: `${ms('6h')}`, label: '6 hours before the event', short: '6 hours' },
  {
    value: `${ms('12h')}`,
    label: '12 hours before the event',
    short: '12 hours',
  },
  {
    value: `${ms('24h')}`,
    label: '24 hours before the event',
    short: '24 hours',
  },
  { value: `${ms('2d')}`, label: '2 days before the event', short: '2 days' },
  { value: `${ms('7d')}`, label: '7 days before the event', short: '7 days' },
];

export const hardcodedFollowUpOffsets: OffsetOption[] = [
  { value: '0', label: 'Immediately after the event', short: 'Immediately' },
  { value: `${ms('1h')}`, label: '1 hour after the event', short: '1 hour' },
  { value: `${ms('3h')}`, label: '3 hours after the event', short: '3 hours' },
  { value: `${ms('6h')}`, label: '6 hours after the event', short: '6 hours' },
  {
    value: `${ms('12h')}`,
    label: '12 hours after the event',
    short: '12 hours',
  },
  {
    value: `${ms('24h')}`,
    label: '24 hours after the event',
    short: '24 hours',
  },
];

export const hardcodedOffsets = {
  [MESSAGE_TYPES.CONFIRMATION]: hardcodedConfirmationOffsets,
  [MESSAGE_TYPES.REMINDER]: hardcodedReminderOffsets,
  [MESSAGE_TYPES.FOLLOW_UP]: hardcodedFollowUpOffsets,
};
